import React, { useEffect } from 'react'
import useAuth from '../../../hooks/useAuth'
import { Helmet } from '@dr.pogodin/react-helmet'
import { Card as MuiCard, CardContent, Divider, LinearProgress, Typography } from '@mui/material'
import styled from '@emotion/styled'
import { spacing } from '@mui/system'
import { useTranslation } from 'react-i18next'
import CompaniesGrid from '../../../components/entities/CompaniesGrid'
import CompanyApi from '../../../api/CompanyApi'

const Card = styled(MuiCard)(spacing)

const companyApi = new CompanyApi()

function CompaniesView() {
    const { t } = useTranslation()
    const { isAuthenticated } = useAuth()
    const [companies, setCompanies] = React.useState(null)

    useEffect(() => {
        async function fetchData() {
            if (!isAuthenticated) return
            const fetchedCompanies = await companyApi.findAll()
            // sort by name
            fetchedCompanies.sort((a, b) => (a.name > b.name ? 1 : -1))
            setCompanies(fetchedCompanies)
        }
        fetchData()
    }, [isAuthenticated])

    return (
        <React.Fragment>
            <Helmet title={t('entities.company.plural')} />
            <Typography
                variant='h3'
                gutterBottom
                sx={{
                    display: 'block',
                }}
            >
                {t('entities.company.plural')}
            </Typography>
            <Divider my={6} />
            <Card mb={6}>
                <CardContent>
                    {!companies && <LinearProgress />}
                    {companies && (
                        <CompaniesGrid companies={companies} detailsPath={(c) => `/admin/companies/${c.id}`} />
                    )}
                </CardContent>
            </Card>
        </React.Fragment>
    )
}

export default CompaniesView
